<!-- Browse by category -->
<section class="browse-cat u-line section-padding">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="section-header-left">
                    <h3 class="text-light-black header-title title">Browse by category <span class="fs-14"><a
                                routerLink="/businesses">See all stores</a></span></h3>
                </div>
            </div>
            <div class="col-12">
                <div class="category-slider swiper-container">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" *ngFor="let storeType of storeTypeOptions">
                            <a class="categories" (click)="onCategoryClick(storeType)" style="cursor: pointer;">
                                <div class="icon text-custom-white bg-light">
                                    <img width="50" height="50" style="width: 50px; height: 50px;" [src]="storeType | businessTypeToIcon" class="rounded-circle"
                                        [alt]="storeType === 'all' ? 'All categories' : (storeType | storeType)">
                                </div>
                                <span class="text-light-black cat-name">
                                    {{ storeType === 'all' ? 'All' : (storeType | storeType) }}
                                </span>
                            </a>
                        </div>
                    </div>
                    <!-- Add Arrows -->
                    <div class="swiper-button-next"></div>
                    <div class="swiper-button-prev"></div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Browse by category -->
